var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShortLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 298.971,
    height: 348.501,
    viewBox: "0 0 298.971 348.501",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(-29.166)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2125041700768",
    transform: "translate(29.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105849",
    "data-name": "Path 105849",
    d: "M440.435,104.8a94.208,94.208,0,0,1,94.208,94.208q0,1.246-.032,2.484h0v113.6A149.481,149.481,0,0,1,290.95,199.006c0-66.245.763-132.687.763-199.015,14,0,36.17,14.843,36.17,35.688v64.955A149.48,149.48,0,0,1,554.8,295.252l-.263-83.483c-.09-28.33-.639-46.333-18.064-73.729A113.736,113.736,0,1,0,498.56,296.79V273.15A94.21,94.21,0,1,1,440.436,104.8Zm0,36.59a57.619,57.619,0,1,1-57.619,57.618A57.618,57.618,0,0,1,440.435,141.389Z",
    transform: "translate(-290.95 0.01)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortLogoWhite);
export default __webpack_public_path__ + "static/media/short-logo-white.a78afe476836e05a23b6f69318bbffcd.svg";
export { ForwardRef as ReactComponent };